// FETCH_FAMILY_MONEY_LANDING_PAGE

import React, { Component, Fragment } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";

import { setA11yContent } from "../../NavigationHelper/actions";
import { fetchPageContent } from "../../DownloadAndDelete/actions";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions";
import { media } from "utils/style";
import { Tile as CommonTile } from "common-components/Tile";
import { ButtonWithArrowNew } from "common-components/Buttons";

import DownloadAndDelete from "../../DownloadAndDelete/DownloadAndDelete";
import YourRequestBanner from "../../LoggedInLanding/components/YourRequestBanner/YourRequestBanner";
import { checkNestedObject } from "utils/checkNestedObject";

import FetchPageContent from "../../../../hoc/FetchPageContent";

class FamilyMoneyLandingPage extends Component {
  state = {
    displayBox: ""
  };

  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "breadCrumbs")) {
      const { breadCrumbs } = this.props.pageContent;
      this.props.setBreadcrumbList([{ label: breadCrumbs.landingPage, path: "/privacy/secure/your-data" }]);
    }

    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent(
        "verizon cloud",
        this.props.pageContent.sc_pagetitle,
        this.props.pageContent.seo_description
      );
    }

    // if (document.getElementsByClassName("ott_landing_button")) {
    //   const elements = document.getElementsByClassName("ott_landing_button");
    //   let clickedElement = null;

    //   const handleClick = function() {
    //     clickedElement = this;
    //     const attribute = this.getAttribute("data-button-val");
    //     updateState(attribute);
    //   };

    //   const closeContent = () => {
    //     this.setState({ displayBox: "" });
    //     for (let el of elements) {
    //       el.style.fontFamily = "Verizon-NHG-eDS";
    //       el.classList.remove("buttonActive");
    //     }
    //   };

    //   const updateState = attribute => {
    //     if (!this.state.displayBox) {
    //       this.setState({ displayBox: attribute }, () => {
    //         const displayContent = document.getElementById(this.state.displayBox);

    //         if (displayContent) {
    //           clickedElement.style.fontFamily = "NeueHaasGroteskTextBold";
    //           clickedElement.classList.add("buttonActive");
    //           displayContent.style.display = "block";

    //           const closeButton = displayContent.getElementsByClassName("ott_close_button");

    //           if (closeButton && closeButton[0]) {
    //             closeButton[0].addEventListener(
    //               "click",
    //               function() {
    //                 closeContent();
    //                 displayContent.style.display = "none";
    //               },
    //               false
    //             );
    //           }
    //         } else {
    //           this.setState({ displayBox: "" });
    //         }
    //       });
    //     }
    //   };

    //   for (let el of elements) {
    //     el.addEventListener("click", handleClick, false);
    //   }
    // }
  }

  componentWillUnmount() {
    this.props.setBreadcrumbList([]);
  }

  render() {
    const {
      sections: [
        [
          topOfPage,
          controlsSection,
          informationRequests,
          {
            tileContent: [tileContent]
          },
          download_pending,
          request_cancelled,
          download_complete
        ],
        modalContent
      ]
    } = this.props.pageContent;

    const bannerContent = {
      download_complete,
      download_pending,
      request_cancelled
    };

    return (
      <Fragment>
        <YourRequestBanner bannerContent={bannerContent} />
        <Container style={{ marginTop: "0", paddingTop: "0" }}>
          <SubContainer>
            <H1>{convertStringToElements(topOfPage.section_title)}</H1>
            <HeaderDesc>{convertStringToElements(topOfPage.section_description)}</HeaderDesc>


            <div style={{ maxWidth: "596px" }}>
              <DownloadAndDelete downloadAndDeleteData={informationRequests} modalContent={modalContent} />
            </div>

            <div style={{ maxWidth: "596px" }}>
              <H2>{convertStringToElements(controlsSection.section_title)}</H2>
              {controlsSection.links.map(item => (
                <div key={item.text} style={{ marginBottom: "28.2px" }}>
                  <ButtonWithArrowNew buttonRole="reactLink" to={item.link}>
                    {item.text}
                  </ButtonWithArrowNew>
                  <P>{convertStringToElements(item.desc)}</P>
                </div>
              ))}
            </div>

            <H2 style={{ margin: "64px 0 30px 0" }}>
              {convertStringToElements(tileContent.title)}
            </H2>

            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {tileContent.list.map(tile => (
                <Tile key={tile.heading} href={tile.tileLink} linkText={tile.linkText}>
                  {tile.heading}
                </Tile>
              ))}
            </div>
          </SubContainer>
        </Container>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ loadingAndErrorState: { loading }, pageContent }) => ({
  loading,
  pageContent
});

FamilyMoneyLandingPage.propTypes = {
  setA11yContent: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
};

export default compose(
  connect(
    mapStateToProps,
    { setA11yContent, fetchPageContent, setBreadcrumbList }
  ),
  FetchPageContent
)(FamilyMoneyLandingPage);

const Tile = styled(CommonTile)`
  flex-basis: 48%;  
  margin-right:24px;
 background-color:#F6F6F6;
  span.tile_desc{
  max-width:548px;
  font-family: 'Verizon-NHG-eTX', Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  }

  span.tile_text{
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 700; 
    font-size: 20px;
    line-height: 24px;
    ${media.mobile`
    font-size: 16px;
  `}
}


  ${media.mobile`
    flex-basis: 100%;
    margin-right:0px;
    margin-bottom:12px;
  `}
`;

const Container = styled.div`
  max-width: 1272px;
  margin: 0 auto;
  padding: 48px 0;

  ${media.mobile`
    margin: 25px auto;
    padding: 0;
  `};
`;

const SubContainer = styled.div`
  padding: 0 20px;

  ${media.mobile`
    padding: 0 16px;
  `};
`;

const HeaderDesc = styled.div`
 max-width: 596px;
 font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
 font-size: 16px;
 font-weight: 400;
 line-height: 20px;
 letter-spacing: 0.5px;

  p:first-of-type {
    margin-bottom: 24px;
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-size: 16px;
   font-weight: 400;
   line-height: 20px;
   letter-spacing: 0.5px;
  }
`;

const H1 = styled.h1`
font-size: 48px;
line-height: 48px;
font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
font-weight: 300;
font-style: normal;
max-width: 565px;
margin-top: 64px;
margin-bottom: 32px;

  ${media.mobile`
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
  margin-top: 40px;
  `};
`;

const H2 = styled.h2`
  margin-top:48px;
  margin-bottom: 20px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  span {
    height: 5px;
    display: block;
    width: 49px;
    background-color: #d52b1e;
    margin-top: 16px;
  }

  ${media.mobile`
    margin-top: 28px;
    margin-bottom: 12px;
    font-size: 24px;	
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-weight: 700;
    line-height: 28px;
	`};
`;

const P = styled.p`
  margin-top: 5px;
  max-width: 526px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; 
  letter-spacing: 0.5px;
  color:#6F7171;

  ${media.mobile`
  max-width: 296px;
  font-family: Verizon NHG eTX, Helvetica, Arial, sans-serif;;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  `};
`;